import { render } from "./GiveExtraCredit.vue?vue&type=template&id=e11e4fc2"
import script from "./GiveExtraCredit.vue?vue&type=script&lang=js"
export * from "./GiveExtraCredit.vue?vue&type=script&lang=js"

import "./GiveExtraCredit.vue?vue&type=style&index=0&id=e11e4fc2&lang=css"

import exportComponent from "/codebuild/output/src310475096/src/AstopiaAdminPanel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__